const routes = [
  {
    index: true,
    label: 'Yunlin Qi',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Playground',
    path: '/playground',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
